import {UserWithRole} from '@wove/api/types'
import UserRow from './UserRow'
import { useUpdateUserRoleMutation } from '@wove/api'
import { useCallback } from 'react'
import { toast } from 'sonner'

interface UsersTableProps {
  users: UserWithRole[]
}

const UsersTable = ({ users }: UsersTableProps) => {
  const [, executeUpdateRole] = useUpdateUserRoleMutation()

  const changeRole = useCallback(
    async (userId: string, role: string) => {
      try {
        await executeUpdateRole({ userId, role })
      } catch (error) {
        toast.error('Failed to update user role')
      }
    },
    [executeUpdateRole],
  )

  return (
    <div className="space-y-4">
      {users.map((user) => {
        return <UserRow key={user.id} member={user} changeRole={changeRole} />
      })}
    </div>
  )
}

export default UsersTable
